import { Constant } from '@genial/config';
import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { fixedIncomeMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { OperationType } from '../../../../contexts/constants';
import { AssetNoticesNormalized } from '../../../AssetNotices';

import { FixedIncomeSellAsset } from '.';

export const fixedIncomeTableHead: TableHeadItemRecurse[] = [
  { title: 'Produto', flex: 3 },
  { title: 'Quantidade disponível', flex: 2 },
  { title: 'IR', flex: 2 },
  { title: 'Valor líquido', flex: 2 },
  { title: 'Quantidade a resgatar', flex: 2 },
  { title: 'Disponível em conta', flex: 2 },
  { title: '', flex: 2 },
];

export const fixedIncomeSellConstants = {
  id: 'fixedIncome',
  typeGetterId: 'fixedIncomeSell',
  title: 'Renda Fixa',
  operationId: 2,
  operationName: 'Resgatar',
  operationType: 'sell' as OperationType,
  color: 'product.rf' as ColorTypes.Option,
  principalComponent: FixedIncomeSellAsset,
  tableHead: fixedIncomeTableHead,
  hideTableHead: false,
  marketStatusSelector: fixedIncomeMarketStatusQuery,
  hasFilters: false,
  mountFilters: (): FilterModalTypes.FilterType[] => [],
  hasCategories: false,
  categoriesLabel: '',
  categoriesField: 'productSbCategory',
  mountCategories: () => [],
  captions: [],
  groupNotices: false,
  notices: [] as AssetNoticesNormalized[],
  hasRefresher: false,
  unleashFlag: '',
  unleashFlagBatchTicket: Constant.UnleashBasketFixedIncomeToggle,
  unleashFlagCustomers: Constant.UnleashCustomersFixedIncomeToggle,
} as const;
